module.exports = __webpack_public_path__ + "img/timer-icon.9aa8c357.svg";